<template>
  <div class="flex items-center gap-4">
    <NAvatar icon label="i-heroicons-bookmark-solid" />

    <NAvatar icon label="i-heroicons-bell-alert-20-solid" />
  </div>
</template>
